export default [{
  path: '/vacation-plane-staff/:id',
  name: 'vacationPlaneStaff',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/vacationPlaneStaff/index')
}]
